// src/NewUPT/homePage/NewUPThomepage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import BodyImageMap from '../shared/BodyImageMap';
import styles from './homepage.module.css';

const NewUPTHomepage = () => {
  // Background for Insurance + Self-Pay (section)
  const insuranceBgStyle = {
    backgroundImage:
      "linear-gradient(135deg, rgba(15,23,42,0.72), rgba(15,23,42,0.8)), url('/home/insurance.png')",
  };

  // Background for No-Fault / Workers' Comp (orange glass + full image)
  const noFaultBgStyle = {
    backgroundImage:
      "linear-gradient(135deg, rgba(248, 153, 72, 0.82), rgba(249, 115, 22, 0.88)), url('/home/nofault-workers.jpg')",
  };

  return (
    <div className={styles.pageWrapper}>
      {/* ===== TOP HERO: WHY NEW U (replaces promotions) ===== */}
      <section
        className={styles.whySection}
        id="why-newu"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(15,23,42,0.55), rgba(15,23,42,0.7)), url('/home/why-newu.png')",
        }}
      >
        <div className={styles.whyOverlay}>
          <div className={styles.whyTextBlock}>
            <h2>Why Choose New U Physical Therapy?</h2>
            <p>
              From your first visit to your last, we focus on comfortable, one-on-one care
              so you can move with less pain and more confidence.
            </p>

            <div className={styles.whyFeatureGrid}>
              <div className={styles.whyFeature}>
                <div className={styles.whyIconCircle}>📍</div>
                <div>
                  <h3>Convenient Locations</h3>
                  <p>Staten Island, Central New Jersey, and North Miami.</p>
                </div>
              </div>

              <div className={styles.whyFeature}>
                <div className={styles.whyIconCircle}>🧑‍⚕️</div>
                <div>
                  <h3>Licensed Therapists</h3>
                  <p>Clinicians who listen to your story and your goals.</p>
                </div>
              </div>

              <div className={styles.whyFeature}>
                <div className={styles.whyIconCircle}>🎯</div>
                <div>
                  <h3>Personalized Plans</h3>
                  <p>Care plans that match your lifestyle—not one-size-fits-all.</p>
                </div>
              </div>
              <div className={styles.whyFeature}>
  <div className={styles.whyIconCircle}>💆‍♂️</div>
  <div>
    <h3>Therapeutic Massage Included</h3>
    <p>
      Hands-on therapeutic massage is built into every session to reduce pain,
      improve mobility, and help your body recover faster.
    </p>
  </div>
</div>




            </div>

            <div className={styles.featureButtonsRow}>
              <Link to="/office" className={styles.primaryButton}>
                View Office Locations
              </Link>
              <Link to="/staff" className={styles.secondaryButton}>
                Meet Our Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ===== BODY MAP SECTION – GLASS CARD ===== */}
      <section className={styles.modelSection} id="pain-map">
        <div className={styles.modelGlass}>
          <div className={styles.modelHeaderRow}>
            <div>
              <h2 className={styles.modelTitle}>Where is your pain?</h2>
              <p className={styles.modelSubtitle}>
                Tap or click a body area to explore common conditions and treatment options.
              </p>
            </div>
            <Link to="/appointments" className={styles.primaryButton}>
              Request an Evaluation
            </Link>
          </div>
          <div className={styles.modelMapWrapper}>
            <BodyImageMap />
          </div>
        </div>
      </section>

      {/* ===== MAIN CTA BAND ===== */}
      <section className={styles.ctaBand}>
        <div className={styles.ctaBandInner}>
          <div className={styles.ctaBandText}>
            <h2>Ready to start physical therapy?</h2>
            <p>
              Register online, check your insurance, and schedule your first visit in just a few steps.
            </p>
          </div>
          <div className={styles.ctaBandButtons}>
            <Link to="/register/patient" className={styles.primaryButton}>
              Register as a New Patient
            </Link>
            <Link to="/insurance" className={styles.secondaryButtonOutline}>
              Check Insurance Options
            </Link>
          </div>
        </div>
      </section>

      {/* ==== INSURANCE + SELF-PAY – NOW TAKES OLD “WHY” SPOT ==== */}
      <section className={styles.insuranceSection} style={insuranceBgStyle}>
        <div className={styles.insuranceOverlay}>
          <div className={styles.sectionHeadingRowDark}>
            <h2>Insurance &amp; Self-Pay Options</h2>
            <p>
              We work with many major insurance plans and also offer clear self-pay options if you don’t have
              coverage.
            </p>
          </div>

          <div className={styles.insuranceColumns}>
            <div className={styles.insuranceColumn}>
              <div className={styles.insuranceIcon}>💳</div>
              <h3>Using Insurance</h3>
              <p>
                We help verify benefits, copays, visit limits, and coverage before treatment starts so you
                know what to expect.
              </p>
            </div>

            <div className={styles.insuranceColumn}>
              <div className={styles.insuranceIcon}>💵</div>
              <h3>No Insurance? Self-Pay</h3>
              <p>
                Simple, upfront self-pay pricing—great for high-deductible plans or out-of-network situations.
              </p>
            </div>
          </div>

          <div className={styles.insuranceButtonsRow}>
            <Link to="/insurance" className={styles.primaryButton}>
              View Accepted Insurance
            </Link>
            <Link to="/register/patient" className={styles.insurancePrimaryButton}>
              Start as a Patient
            </Link>
            <Link to="/contact" className={styles.secondaryButtonOutline}>
              Ask About Rates
            </Link>
          </div>
        </div>
      </section>

      {/* ==== SECTION: COMMON PROBLEMS – BOXY CARD WITH CLICKABLE BUBBLES ==== */}
      <section className={styles.conditionsSection}>
        <div className={styles.conditionsInner}>
          <div className={styles.conditionsImageCol}>
            <img
              src="/home/common-problems.png"
              alt="Common problems illustration"
              className={styles.conditionsImage}
            />
          </div>
          <div className={styles.conditionsContent}>
            <div className={styles.conditionsTag}>Common Problems We Treat</div>
            <h2>From everyday aches to bigger injuries.</h2>
            <p>
              Whether pain came from sports, work, or daily life, our team helps you move with less pain and
              more confidence.
            </p>
            <p className={styles.conditionsIntroSmall}>
              Tap a body region below to jump straight to information about that area.
            </p>

            {/* Bubble-style quick links to pain pages */}
            <div className={styles.chipGrid}>
              <Link to="/pain/headNeckBack" className={styles.chip}>
                Head &amp; Neck
              </Link>
              <Link to="/pain/shoulderRegion" className={styles.chip}>
                Shoulder
              </Link>
              <Link to="/pain/elbowForearm" className={styles.chip}>
                Elbow &amp; Forearm
              </Link>
              <Link to="/pain/wristHand" className={styles.chip}>
                Wrist &amp; Hand
              </Link>
              <Link to="/pain/upperBack" className={styles.chip}>
                Upper Back
              </Link>
              <Link to="/pain/lowerBack" className={styles.chip}>
                Lower Back &amp; Sciatica
              </Link>
              <Link to="/pain/pelvisHipsFront" className={styles.chip}>
                Hip &amp; Groin
              </Link>
              <Link to="/pain/thighFront" className={styles.chip}>
                Thigh &amp; Quad
              </Link>
              <Link to="/pain/kneeBack" className={styles.chip}>
                Knee Pain
              </Link>
              <Link to="/pain/ankleFoot" className={styles.chip}>
                Ankle &amp; Foot
              </Link>
            </div>

            <p className={styles.conditionsNoteBox}>
              Not sure where your pain fits? You can always use the body map above or schedule an evaluation
              and talk directly with a therapist.
            </p>

            <div className={styles.featureButtonsRow}>
              <a href="#pain-map" className={styles.primaryButton}>
                Explore Pain by Body Area
              </a>
              <Link to="/appointments" className={styles.secondaryButton}>
                Schedule a Visit
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ==== SECTION: NO-FAULT & WORKERS COMP – ORANGE GLASS, NO BULLET POINTS ==== */}
      <section className={styles.noFaultSection}>
        <div className={styles.noFaultCard} style={noFaultBgStyle}>
          <div className={styles.noFaultContent}>
            <h2>No-Fault &amp; Workers’ Compensation</h2>
            <p>
              Injured in a car accident or at work? Our team is experienced with no-fault and workers’ comp
              cases and can help with both your recovery and the paperwork.
            </p>

            <div className={styles.noFaultBadges}>
              <div className={styles.noFaultBadge}>
                <div className={styles.noFaultIcon}>📄</div>
                <span>Help with forms & authorizations</span>
              </div>
              <div className={styles.noFaultBadge}>
                <div className={styles.noFaultIcon}>🤝</div>
                <span>Coordination with doctors, lawyers & case managers</span>
              </div>
              <div className={styles.noFaultBadge}>
                <div className={styles.noFaultIcon}>🕊️</div>
                <span>Safe, step-by-step return to daily life</span>
              </div>
            </div>

            <div className={styles.noFaultButtonsRow}>
              <Link to="/no-fault" className={styles.noFaultButtonPrimary}>
                Learn About No-Fault
              </Link>
              <Link to="/workers-comp" className={styles.noFaultButtonSecondary}>
                Learn About Workers’ Comp
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CLINIC TOOLS – WINDOW + BOXES ===== */}
      <section className={styles.clinicToolsSection}>
        <div className={styles.clinicToolsInner}>
          <h2 className={styles.clinicTitle}>Quick Links</h2>
          <p className={styles.clinicSubtitle}>
            Use these shortcuts to get where you need to go in the New U portal.
          </p>

          <div className={styles.clinicGrid}>
            <Link to="/office" className={styles.clinicCard}>
              <h3>Our Offices</h3>
              <p>View addresses, hours, and contact info for each location.</p>
            </Link>

            <Link to="/insurance" className={styles.clinicCard}>
              <h3>Insurance Details</h3>
              <p>Check accepted plans and coverage information.</p>
            </Link>

            <Link to="/staff" className={styles.clinicCard}>
              <h3>Meet the Team</h3>
              <p>Learn more about our therapists and providers.</p>
            </Link>

            <Link to="/appointments" className={styles.clinicCard}>
              <h3>Schedule an Appointment</h3>
              <p>See available times and request your visit.</p>
            </Link>

            <Link to="/login/patient" className={styles.clinicCard}>
              <h3>Patient Login</h3>
              <p>Access your dashboard, appointments, and more.</p>
            </Link>

            <Link to="/dashboard/doctor" className={styles.clinicCard}>
              <h3>Provider Login</h3>
              <p>For staff and providers using the New U portal.</p>
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CONTACT / QUESTION FORM ===== */}
      <section className={styles.contactSection}>
        <div className={styles.contactCard}>
          <h3 className={styles.contactTitle}>Have Questions About Your Care?</h3>
          <p className={styles.contactNote}>
            Reach out and our team will help guide you through appointments, insurance,
            and treatment options.
          </p>

          <div className={styles.contactBtnRow}>
            <a href="tel:+1-000-000-0000" className={styles.btnPrimary}>
              Call Our Office
            </a>
            <Link to="/office" className={styles.btnGhost}>
              View Office Locations
            </Link>
          </div>

          <form
            className={styles.quickForm}
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input
              type="text"
              className={styles.input}
              placeholder="Your Name"
              required
            />
            <input
              type="email"
              className={styles.input}
              placeholder="Your Email"
              required
            />
            <textarea
              className={styles.textarea}
              placeholder="How can we help you?"
              required
            />
            <button type="submit" className={styles.submit}>
              Send Message
            </button>
          </form>
        </div>
      </section>

      {/* ===== JUDO PROMO SECTION (Unified Mobile-Style Layout) ===== */}
      <section className={styles.judoSection}>
        <div className={styles.judoCard}>
          <div className={styles.judoLeft}>
            <div className={styles.judoLogoWrap}>
              <img src="/home/judologo.png" alt="Judo NJ Logo" className={styles.judoLogo} />
            </div>
            <h3 className={styles.judoTitle}>From Physical Therapy<br />to Judo</h3>
          </div>

          <p className={styles.judoSubtitle}>
            Continue your progress, build strength, and boost confidence with safe and
            structured Judo training in New Jersey.
          </p>

          <a
            href="https://judonj.com/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.judoButton}
          >
            Train at JudoNJ.com
          </a>
        </div>
      </section>
    </div>
  );
};

export default NewUPTHomepage;
